<template>
  <div style="height: 100%; color: #FAFAFA;">
    <label style="padding: 20px 0px 10px 30px;">加湿机</label>
    <div v-if="deviceDataList.length > 0" style="height: 85%">
      <!-- 2个及以下设备直接显示 -->
      <template v-if="pageList.length === 1">
        <el-row style="height: 100%;">
          <el-col :span="12" v-for="device in pageList[0]" :key="device.deviceName" class="text-center">
            <el-row>
              <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                {{ device.deviceName }}
              </label>
            </el-row>
            <el-row style="margin-top: 1vh;">
              <el-col :span="12" class="text-right text-blueGrey">开关机状态：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.acs }}</el-col>
            </el-row>
             <el-row style="margin-top: 1vh;">
              <el-col :span="12" class="text-right text-blueGrey">当前模式：</el-col>
              <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humSetst }}</el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <!-- 超过2个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%; z-index: 0">
           <el-carousel-item v-for="(page, index) in pageList" :key="index">
            <el-row style="height: 100%;">
              <el-col :span="12" v-for="device in page" :key="device.deviceName" class="text-center">
                 <el-row>
                  <label :style="{ lineHeight: '3vh', color: (device.status !== undefined && device.status !== 0) ? '#ff0000' : '#fff' }">
                    {{ device.deviceName }}
                  </label>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="12" class="text-right text-blueGrey">开关机状态：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.acs }}</el-col>
                </el-row>
                <el-row style="margin-top: 1vh;">
                  <el-col :span="12" class="text-right text-blueGrey">当前模式：</el-col>
                  <el-col :span="6" class="text-left" style="margin-left: 10px;">{{ device.humSetst }}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%; padding-top: 20%">
      <no-data></no-data> 
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomHumidifier",
  components: { NoData },
  data() {
    return {
      deviceDataList: [],
      pageList: [],
      pageSize: 2, 
      deviceType: 'PM_HUM', 
      pointCodes: 'acs,hum_setst' 
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getHumidifierData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getHumidifierData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointValues } = res.data;
          if (devices && devices.length > 0) {
            this.deviceDataList = this.processData(devices, devicePointValues);
            if (this.deviceDataList.length > 0) {
              this.pageList = this.chunkData(this.deviceDataList, this.pageSize);
            } else {
              this.pageList = [];
            }
          } else {
            this.deviceDataList = [];
            this.pageList = [];
          }
        } else {
          this.deviceDataList = [];
          this.pageList = [];
        }
      }).catch(() => {
        this.deviceDataList = [];
        this.pageList = [];
      });
    },
    processData(devices, devicePointValues) {
      const result = [];
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        if (device && values) {
          let acsText = '--';
          if (values[0] == 0) acsText = '关机';
          else if (values[0] == 1) acsText = '开机';
          else if (values[0] != null) acsText = values[0];

          let humSetstText = '--';
          if (values[1] == 0) humSetstText = '自动';
          else if (values[1] == 1) humSetstText = '手动';
          else if (values[1] == 2) humSetstText = '智能';
          else if (values[1] != null) humSetstText = values[1];

          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            acs: acsText,
            humSetst: humSetstText,
            alarm7: values[2],
            alarm8: values[3]
          });
        }
      }
      return result;
    },
    chunkData(data, size) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        result.push(data.slice(i, i + size));
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}
</style>
